'use strict';

var toastr = require('toastr');
var GridSavePostDepartureButtonController = function GridSavePostDepartureButtonController($scope, $rootScope, $log, flightPostDepartureDataService, saveButtonUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.savePostDepartureChanges = function () {
    var rows = saveButtonUtilsService.getEditedRows(gridPanel.jqxGridSettings);
    flightPostDepartureDataService.updateIgnorePostDepartureStatus(rows).then(onRequestSuccess, onRequestFail);
  };
  $scope.$on('save-modal:flight-analysis-post-departure-recordChanges', $scope.savePostDepartureChanges);
  function onRequestSuccess() {
    $rootScope.$broadcast('clearChangedValue');
    $rootScope.$broadcast('overrides:clear-cells');
    toastr.success('Your overrides have been successfully submitted.');
  }
  function onRequestFail() {
    $log.error('FlightGridsController: onRequestFail - An error has occurred');
    toastr.error('An error has occurred. Please try again.');
  }
};
GridSavePostDepartureButtonController.$inject = ['$scope', '$rootScope', '$log', 'flightPostDepartureDataService', 'SaveButtonUtilsService'];
module.exports = GridSavePostDepartureButtonController;